var currentimage = 1;


$(document).ready(function (){
 
    if( $(".front_image").length > 0 ){
        $("#frontpage_images_" + currentimage).show();
        setInterval( function() { changeBg(); },3000 );
    }


});

getRandomFeedback = function( page ){
                   var randomNumber = Math.floor( Math.random() * feedbacks.length );
               	while( feedbacks[randomNumber]['feedback'].length > 140){
               		randomNumber = Math.floor( Math.random() * feedbacks.length );
               	}
               	return feedbacks[randomNumber];
               }
               
               changeFeedback = function( currentnumber ){
               	$("#feedbackcontent").fadeOut("slow",function(){
               		var newfeedback = getRandomFeedback();
                   // bug in firefox:
               	//	if( newfeedback['name'] == feedback['name'] ){
               	//		newfeedback = getRandomFeedback();
               	//	}
               		$("#feedbackcontent").html( newfeedback['feedback'] + '<span class="name">' + newfeedback['name'] + '</span>');
               		$("#feedbackcontent").fadeIn("slow");
               	});
               }
               
               
               changeBg = function(  ) {
               	var totalimages = $('.front_image').length;
               	var nextimage = currentimage + 1;
               	if( currentimage == totalimages ){
               	   nextimage = 1;
               	}
               	$('#frontpage_images_' + currentimage ).fadeOut( 1500 );
               	$('#frontpage_images_' + nextimage ).fadeIn( 1500 );
               	currentimage = nextimage;
               }


isDev = function(){
    !!window.location.search.match(/dev/i);
}

getQueryVariable = function(variable) {
	var query = window.location.search.substring(1);
	var vars = query.split("&");
	for (var i=0;i<vars.length;i++) {
		var pair = vars[i].split("=");
		if (pair[0] == variable) {
			return pair[1];
		}
	}
}

var Browser = {
	Version: function() {
		var version = 999; // we assume a sane browser
		if (navigator.appVersion.indexOf("MSIE") != -1)
		// bah, IE again, lets downgrade version number
		version = parseFloat(navigator.appVersion.split("MSIE")[1]);
		return version;
	}
}

getRandomFeedback = function( page ){
	var randomNumber = Math.floor( Math.random() * feedbacks.length );
	while( feedbacks[randomNumber]['feedback'].length > 140){
		randomNumber = Math.floor( Math.random() * feedbacks.length );
	}
	return feedbacks[randomNumber];
}

changeFeedback = function( currentnumber ){
	$("#feedbackcontent").fadeOut("slow",function(){
		var newfeedback = getRandomFeedback();
		$("#feedbackcontent").html( newfeedback['feedback'] + '<span class="name">' + newfeedback['name'] + '</span>');
		$("#feedbackcontent").fadeIn("slow");
	});
}



String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
}

var isDev = !!window.location.search.match(/dev/i);

getQueryVariable = function(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i=0;i<vars.length;i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  } 
}

var Browser = {
  Version: function() {
    var version = 999; // we assume a sane browser
    if (navigator.appVersion.indexOf("MSIE") != -1)
      // bah, IE again, lets downgrade version number
      version = parseFloat(navigator.appVersion.split("MSIE")[1]);
    return version;
  }
}